module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/50eb945c10ef707c968c854a30284594.png";